/*
 * @Author: libo 
 * @Date: 2020-11-13 16:54:37 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2021-11-15 16:27:39
 */

<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <meter-particulars-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></meter-particulars-form>
  </j-modal>
</template>

<script>

  import MeterParticularsForm from './MeterParticularsForm'
  export default {
    name: 'MeterParticularsModal',
    components: {
      MeterParticularsForm
    },
    data () {
      return {
        title:'',
        width:1000,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
          console.log();
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.$refs.realForm.shut();
        this.close()
      }
    }
  }
</script>